import { Navigate } from 'react-router-dom'
import { useBranding } from '../contexts/BrandingContext'

/**
 * Redirects to /login when in group mode (branded domains).
 * Use to block access to Register, Manufacturer Login, and Admin Login on group domains.
 */
const BlockInGroupMode = ({ children }) => {
  const { isGroupMode } = useBranding()
  if (isGroupMode) {
    return <Navigate to='/login' replace />
  }
  return children
}

export default BlockInGroupMode
